import {mapActions, mapState} from "vuex";

export default {
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    ...mapActions(['getUserInfo', 'getUserInfo2Interceptor', 'checkPicCode'])
  }
}
